import React, { Component, ReactNode } from "react";
import PropTypes from "prop-types";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faTimes, faEllipsisV } from "@fortawesome/free-solid-svg-icons";
import {
  Wrapper,
  MenuTrigger,
  MenuOptions,
  Option,
  OptionText,
  OptionDescription,
} from "./styles/kanban-mobile-menu";

export interface IKanbanMobileMenuProps {
  toggleHowToModal: () => void;
  positionsFilled?: number;
  numberOfPositions?: number;
}

interface IKanbanMobileMenuState {
  dropdownActive: boolean;
}

class KanbanMobileMenu extends Component<
  IKanbanMobileMenuProps,
  IKanbanMobileMenuState
> {
  static propTypes = {
    toggleHowToModal: PropTypes.func.isRequired,
    positionsFilled: PropTypes.number,
    numberOfPositions: PropTypes.number,
  };

  static defaultProps = {
    positionsFilled: null,
    numberOfPositions: null,
  };

  state = {
    dropdownActive: false,
  };

  handleOptionsDropwdown = (): void => {
    const { dropdownActive } = this.state;

    this.setState(() => ({
      dropdownActive: !dropdownActive,
    }));
  };

  render(): ReactNode {
    const { dropdownActive } = this.state;
    const { toggleHowToModal, positionsFilled, numberOfPositions } = this.props;

    return (
      <Wrapper>
        <MenuTrigger onClick={this.handleOptionsDropwdown}>
          {dropdownActive ? (
            <FontAwesomeIcon icon={faTimes} />
          ) : (
            <FontAwesomeIcon icon={faEllipsisV} />
          )}
          {dropdownActive && (
            <MenuOptions>
              {numberOfPositions > 1 && (
                <Option>
                  <OptionText>
                    Positions filled:{" "}
                    <strong>
                      {positionsFilled} / {numberOfPositions}
                    </strong>
                  </OptionText>
                  <OptionDescription>
                    This displays the number of offers accepted, out of the
                    number of positions available on this role.
                  </OptionDescription>
                </Option>
              )}
              <Option clickable onClick={toggleHowToModal}>
                <OptionText>Help</OptionText>
              </Option>
            </MenuOptions>
          )}
        </MenuTrigger>
      </Wrapper>
    );
  }
}

export default KanbanMobileMenu;
